import { useFormContext, useWatch } from 'react-hook-form';

import Checkbox from 'src/refactor_shared/ui/checkbox';
import { ScheduleDateItem } from './schedule-date-item';

const ScheduleSameTime = () => {
  const { setValue, control } = useFormContext();
  const sameTimeWatcher = useWatch({
    control,
    name: '7'
  });

  return (
    <div className="py-20 flex flex-col gap-10 items-start w-full">
      <Checkbox
        registerName="7"
        labelTitle="수업 시간이 항상 같아요"
        onCustomChange={e => {
          e.target.checked
            ? setValue('7', [
                {
                  startAt: '',
                  endAt: ''
                }
              ])
            : setValue('7', false);
        }}
        checked={Boolean(sameTimeWatcher && sameTimeWatcher.length)}
      />
      {sameTimeWatcher ? (
        <ScheduleDateItem.Same
          day="7"
          applyMaxWidth={false}
          watcher={sameTimeWatcher}
        />
      ) : null}
    </div>
  );
};
export default ScheduleSameTime;
